module.exports = __webpack_public_path__ + "img/Opty_clicked.475af5d0.svg";